// Component
import { PricetableSection } from './pricetable-section.component'

export default PricetableSection
